import { configureStore, PreloadedState } from '@reduxjs/toolkit';
import { FLUSH, PAUSE, PERSIST, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist';
import rootReducer from './reducers';
import { usersAPI } from './services/usersAPI';
import { teamsAPI } from './services/teamsAPI';
import { userDelegationsAPI } from './services/userDelegationsAPI';
import { groupsAPI } from './services/groupsAPI';
import { featuresAPI } from './services/featuresAPI';
import { applicationsAPI } from './services/applicationsAPI';
import { platformsAPI } from './services/platformsAPI';
import { rolesAPI } from './services/rolesAPI';

// https://stackoverflow.com/questions/66315413/type-definitions-for-redux-toolkit-store-with-preloadedstate
export const setupStore = (preloadedState?: PreloadedState<any>) =>
  configureStore({
    reducer: rootReducer,
    ...preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      })
        .concat(usersAPI.middleware)
        .concat(teamsAPI.middleware)
        .concat(userDelegationsAPI.middleware)
        .concat(groupsAPI.middleware)
        .concat(featuresAPI.middleware)
        .concat(applicationsAPI.middleware)
        .concat(platformsAPI.middleware)
        .concat(rolesAPI.middleware),
  });

export type Store = ReturnType<typeof setupStore>;
export type RootState = ReturnType<Store['getState']>;
export type AppDispatch = Store['dispatch'];

// setup store
export const store = setupStore();

// persist redux store so that the state gets rehydrated on page refresh
export const persistor = persistStore(store);
